import React from "react";
import { makeStyles, Typography, Box } from "@material-ui/core";
import Button from "components/design-system/atoms/Button";
import Search from "./assets/search.svg";
import { useSpring, animated, config } from "react-spring";
import useFilters from "hooks/useFilters";
import { getFilterActivation, resetEligibility } from "components/localOfferEligibility/LocalOfferEligibility";

export default function NoResult({ removeCatalogsFromRefinementList }) {
  const classes = useStyle();
  const [{ searchState: activeFilters }, dispatch] = useFilters();

  const resetFilters = () => {
    dispatch({ type: "resetFilters", searchState: {} });
  };
  const resetCatalogs = () => {
    resetEligibility();
    removeCatalogsFromRefinementList();
  };

  const searchText = activeFilters.query;
  const isSearchOnly = !!activeFilters.query;
  const content = isSearchOnly
    ? "Nous n'avons pas (encore) de produit correspondant dans notre catalogue, en parcourant nos pages vous trouverez sûrement une autre solution !"
    : "On dirait que vous êtes un peu trop pointilleux, supprimez des filtres pour afficher des résultats.";
  const toUp = useSpring({
    transform: "translateY(0%)",
    from: { transform: "translateY(-5%)" },
    config: config.gentle,
  });

  return (
    <animated.div className={classes.no__results} style={toUp}>
      <div className={classes.picto}>
        <Search />
      </div>

      <div className={classes.content}>
        <Typography variant="h1" color="secondary">
          Aucun résultat {isSearchOnly && `pour "${decodeURIComponent(searchText)}"`}
        </Typography>
        <Typography className={classes.desc} variant="body2">
          <br />
          {content}
        </Typography>
        <Box display="grid" mt={3} gridGap={24}>
          {!isSearchOnly && <Button onClick={resetFilters}>Réinitialiser les filtres</Button>}
          {getFilterActivation() && (
            <>
              <Typography className={classes.desc} variant="body2">
                L&apos;appareil que vous cherchez peut cependant se trouver dans notre catalogue national !
              </Typography>
              <Button version="yellow" onClick={resetCatalogs}>
                Voir le catalogue national
              </Button>
            </>
          )}
        </Box>
      </div>
    </animated.div>
  );
}

const useStyle = makeStyles((theme) => ({
  no__results: {
    textAlign: "left",
    borderRadius: "5px",
    margin: "auto",
    marginTop: theme.spacing(6),
    width: "100%",
    padding: "100px",
    backgroundColor: theme.palette.containerGrey,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      padding: "5%",
      width: "90%",
    },
  },
  cta: {
    fontSize: "14px",
    marginTop: theme.spacing(3),
  },
  desc: {
    color: theme.palette.text.noResult,
  },
  content: {
    paddingLeft: theme.spacing(5),
  },
  picto: {
    width: "150px",

    [theme.breakpoints.down("sm")]: {
      width: "unset",

      marginBottom: theme.spacing(3),
    },
  },
}));
